<template>
  <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path
        d="M12.4999 20L7.49992 16.25V11.9833L0.833252 4.48333V2.5C0.833252 1.83696 1.09664 1.20107 1.56548 0.732233C2.03433 0.263392 2.67021 0 3.33325 0L16.6666 0C17.3296 0 17.9655 0.263392 18.4344 0.732233C18.9032 1.20107 19.1666 1.83696 19.1666 2.5V4.48333L12.4999 11.9833V20ZM9.16658 15.4167L10.8333 16.6667V11.35L17.4999 3.85V2.5C17.4999 2.27899 17.4121 2.06702 17.2558 1.91074C17.0996 1.75446 16.8876 1.66667 16.6666 1.66667H3.33325C3.11224 1.66667 2.90028 1.75446 2.744 1.91074C2.58772 2.06702 2.49992 2.27899 2.49992 2.5V3.85L9.16658 11.35V15.4167Z"
    />
  </svg>
</template>